module.exports = __webpack_public_path__ + "static/media/shell32_23.dfc610d4.ico";